import type { ProductVariant } from '@/entities/product';
import { getOneTimePrice, type PriceDisplay, toPriceDisplay } from '@/widgets/product-details/price/lib';

const isValidPrice = (price: number | undefined | null): price is number =>
    typeof price === 'number' && Number.isFinite(price) && price >= 0;

const getPriceDataDisplay = (priceData: ProductVariant['priceData']): PriceDisplay | null => {
    if (!priceData) return null;

    const { original, current, sale } = priceData;
    if (!isValidPrice(original) || !isValidPrice(current)) return null;

    if (isValidPrice(sale) && sale < original) {
        return { values: [sale, original], variant: 'disabled' };
    }

    return {
        values: [original],
        variant: 'primary',
    };
};

export const getOneTimePriceDisplay = (product: ProductVariant): PriceDisplay =>
    getPriceDataDisplay(product.priceData) ?? toPriceDisplay(getOneTimePrice(product.price));
